// SMART-TOOL-MODAL CONTROLLER — the cross-tree opener for the ONE SmartToolModal
// (Smart Tools epic, owner directive 2026-07-23: "For each tool ... I want the
// options to be presented in a perfectly styled modal instead of being opened
// in the left hand drawer").
//
// Same module-level registered-setter shape as paintModalController: ANY entry
// point — the ribbon's contextual "Edit <recipe>" button, canvas double-click
// on a smart object, the Smart Objects drawer's edit banner, or the Smart Tools
// BROWSER (sibling lane) — opens the singleton without prop-drilling or a
// shared React context. This module holds NO React and imports nothing.
//
// ONE modal at a time: opening for a new target REPLACES the open one (the
// "one floating surface" law). The bumped _id becomes the modal's React key so
// a replace remounts it — re-centering + re-seeding the draft for the new
// target.
let _setConfig = null;
let _seq = 0;

/** The singleton host (SmartToolModalHost in SmartToolModal.jsx) registers its
 *  setState here on mount and returns an unregister fn for unmount. */
export function registerSmartToolModalHost(setter) {
  _setConfig = setter;
  return () => { if (_setConfig === setter) _setConfig = null; };
}

/**
 * Open the smart-tool modal.
 *   config.mode     — 'insert' | 'edit'
 *   config.recipeId — required for 'insert' (which tool to configure);
 *                     ignored for 'edit' (the modal reads the recipe from the
 *                     editor's selected smart object).
 * The host supplies the editor facade; callers pass none of it.
 */
export function openSmartToolModal(config = {}) {
  if (typeof _setConfig !== 'function') {
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn('[smartToolModal] openSmartToolModal called with no SmartToolModalHost mounted');
    }
    return;
  }
  _setConfig({ mode: 'insert', ...config, _id: ++_seq });
}

/** Close the modal if open. Drafts are buffered — closing never touches the
 *  canvas, so there is nothing to revert. */
export function closeSmartToolModal() {
  if (typeof _setConfig === 'function') _setConfig(null);
}
